import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { v1 as uuid } from 'uuid'
import { selectUser } from '../../../store/session'
import { selectAnalyticsParams } from '../../../store/site'
import { withRouter } from 'react-router'
import { setUser } from '../../../lib/analytics'
import { isStaging } from '../../../lib/environment'
import get from 'lodash/get'
import mapValues from 'lodash/mapValues'
import Helmet from 'react-helmet'

class Analytics extends Component {
  componentDidMount () {
    if (this.shouldSendEvent(this.props)) this.sendTrackingEvent(this.props)
    if (this.shouldSetUser(this.props)) this.setUser(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.shouldSendEvent(nextProps)) this.sendTrackingEvent(nextProps)
    if (this.shouldSetUser(nextProps)) this.setUser(nextProps)
  }

  shouldSetUser (props, prevProps = {}) {
    const user = get(props, 'user.id')
    const prevUser = get(prevProps, 'user.id')

    return user && user !== prevUser
  }

  shouldSendEvent ({ track }) {
    return track === 'On'
  }

  setUser (props) {
    const { id, countryCode } = props.user || {}
    setUser(id, { countryCode })
  }

  sendTrackingEvent ({ sku, affiliation, router }) {
    const params = mapValues(router.location.query, (param) => decodeURIComponent(param))
    const donationUuid = params.origin && params.origin.split('/')[1]
    const { amount = 0 } = params

    const payload = {
      'transactionId': uuid(),
      'transactionAffiliation': affiliation || params.event_id,
      'transactionTotal': parseFloat(amount),
      'transactionTimestamp': Date.now(),
      'transactionFirstName': params.first_name,
      'transactionLastName': params.last_name,
      'transactionAnswer1': params.answer_1,
      'transactionAnswer2': params.answer_2,
      'transactionAnswer3': params.answer_3,
      'transactionProducts': [{
        'sku': sku || donationUuid,
        'name': 'Donation',
        'price': parseFloat(amount),
        'quantity': 1
      }],
      'event': 'DonationComplete'
    }

    window.dataLayer = window.dataLayer || []

    return window.dataLayer.push(payload)
  }

  render () {
    return (
      <Helmet>
        <script>
          {`window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
          heap.load("${isStaging() ? process.env.HEAP_ANALYTICS_STAGING_ID : process.env.HEAP_ANALYTICS_PROD_ID}");`}
        </script>
      </Helmet>
    )
  }
}

const mapStateToProps = (store) => ({
  ...selectAnalyticsParams(store),
  user: selectUser(store)
})

export default compose(
  connect(mapStateToProps),
  withRouter
)(Analytics)
